<template>
  <v-dialog
    v-model="active"
    width="80%"
    persistent
  >
    <v-card color="primary">
      <v-card-title>
        <div class="text-h6">
          Evaluacion antecedentes
        </div>
        <v-spacer />
        <v-btn
          icon
          color="error"
          @click="closeDialog()"
        >
          <v-icon>mdi-window-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text v-if="evaluacionAntecedentes">
        <v-container>
          <v-row>
            <v-col cols="6">
              <v-text-field
                label="Evaluado"
                :value="getFullName(
                  evaluacionAntecedentes.Derivacion.Programacion.Expediente.Personal
                )"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
              />
            </v-col>
            <v-col cols="2">
              <v-text-field
                label="Fecha elaboración"
                :value="evaluacionAntecedentes.fechaElaboracion"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
              />
            </v-col>
            <v-col cols="2">
              <v-text-field
                label="Fecha oficio"
                :value="evaluacionAntecedentes.fechaOficio"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
              />
            </v-col>
            <v-col cols="2">
              <v-text-field
                label="Número de oficio de antecedentes"
                :value="evaluacionAntecedentes.oficioAntecedentes"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="5">
              <v-textarea
                label="Observaciones"
                :value="evaluacionAntecedentes.observaciones"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                no-resize
                rows="4"
              />
            </v-col>
            <v-col cols="3">
              <v-card
                class="card"
                color="primary"
              >
                <v-card-text>
                  <v-btn
                    text
                    color="secondary"
                    block
                    @click="download(evaluacionAntecedentes.URL)"
                  >
                    <v-icon class="pr-2">
                      mdi-file-download
                    </v-icon>
                    Oficio de antecedentes
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    active: {
      type: Boolean,
    },

    evaluacionAntecedentes: {
      type: Object,
      required: true,
    },
  },

  methods: {
    closeDialog() {
      this.$emit('close');
    },
  },
};
</script>
